import propTypes from 'prop-types';
import React from 'react';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Moment from 'react-moment';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';
import { deleteCoupon } from '../../actions/coupon';


const CouponItem = ({
    auth, deleteCoupon,
    coupon: { _id, couponcode, minduration, discount, roomtype, date },
}) => {

const navigate = useNavigate();

return (
    <Col>
        <Card border='warning'>
            <Card.Header>
                Coupon Code : {couponcode}
            </Card.Header>
            <Card.Body>
                <table className='room-card-table'>
                    <tbody>
                        <tr>
                            <td>
                                <tr><td>Date</td><td>{<Moment format='YYYY/MM/DD'>{date}</Moment>}</td></tr>
                                <tr><td>Room Type</td><td>{roomtype}</td></tr>
                                <tr><td>Min Duration</td><td>{minduration}</td></tr>
                                <tr><td>Discount %</td><td>{discount}</td></tr>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Card.Body>
            <Card.Footer>
                <i className="fas fa-trash" style={{color:'red', float: 'right'}} onClick={() => deleteCoupon(_id, navigate)}/>
            </Card.Footer>
        </Card>
    </Col>
)};

CouponItem.propTypes = {
    coupon: propTypes.object.isRequired,
    auth: propTypes.object.isRequired,
    deleteCoupon: propTypes.func.isRequired
};

const mapStateToProps = (state) => ({
    auth: state.auth,
});

export default connect(mapStateToProps, { deleteCoupon })(CouponItem);